import { render, staticRenderFns } from "./header-helpdesk-link.vue?vue&type=template&id=2bedbf94&scoped=true&"
import script from "./header-helpdesk-link.vue?vue&type=script&lang=ts&"
export * from "./header-helpdesk-link.vue?vue&type=script&lang=ts&"
import style0 from "./header-helpdesk-link.vue?vue&type=style&index=0&id=2bedbf94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bedbf94",
  null
  
)

export default component.exports